<template>
  <sui-table definition v-if="data">
    <sui-table-header>
      <sui-table-row>
        <sui-table-header-cell :width="5">Account Details</sui-table-header-cell>
        <sui-table-header-cell :width="11">Value</sui-table-header-cell>
      </sui-table-row>
    </sui-table-header>
    <sui-table-body>
      <sui-table-row>
        <sui-table-cell>Locàite User ID</sui-table-cell>
        <sui-table-cell>{{data.ID}}</sui-table-cell>
      </sui-table-row>
      <sui-table-row>
        <sui-table-cell>Email</sui-table-cell>
        <sui-table-cell>{{data.Email}}</sui-table-cell>
      </sui-table-row>
      <sui-table-row>
        <sui-table-cell>Name</sui-table-cell>
        <sui-table-cell>{{data.Name}}</sui-table-cell>
      </sui-table-row>
<!--      <sui-table-row>-->
<!--        <sui-table-cell>UID</sui-table-cell>-->
<!--        <sui-table-cell>{{data.UID}}</sui-table-cell>-->
<!--      </sui-table-row>-->
<!--      <sui-table-row>-->
<!--        <sui-table-cell>Token</sui-table-cell>-->
<!--        <sui-table-cell>-->
<!--          <sui-input class="token" :value="token" disabled transparent></sui-input>-->
<!--        </sui-table-cell>-->
<!--      </sui-table-row>-->
    </sui-table-body>
  </sui-table>
</template>

<script>
    export default {
      name: "UserDetails",
      props: ["data", "token"],
    }
</script>

<style scoped>
  .token {
    width: 100%
  }
</style>
